
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.2) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/b468e3fbe55eb15f4444c0166571278a.png"
              alt="HAUL IT ALL"
              className="h-16 w-auto mb-6 drop-shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Professional hauling and cleanup services serving Riverside County and nearby cities. 
              Fast, reliable, and affordable solutions for all your junk removal needs.
            </p>
            <a
              href="tel:9513509072"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-3 rounded-md font-bold tracking-wider hover:from-cyan-400 hover:to-blue-500 transition-all duration-300 shadow-lg shadow-cyan-500/30 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              <i className="ri-phone-fill"></i>
              (951) 350-9072
            </a>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-cyan-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>Services</h3>
            <ul className="space-y-2">
              {['Furniture Removal', 'Garage Cleanouts', 'Evictions', 'Appliance Removal', 'Donation Pickup'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-cyan-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>Company</h3>
            <ul className="space-y-2">
              {[
                { label: 'About', id: 'about' },
                { label: 'Gallery', id: 'gallery' },
                { label: 'Reviews', id: 'reviews' },
                { label: 'Contact', id: 'contact' }
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-cyan-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>Service Areas</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Riverside</li>
              <li>Corona</li>
              <li>Moreno Valley</li>
              <li>Perris</li>
              <li>Lake Elsinore</li>
              <li>Temecula</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 HAUL IT ALL. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/marketplace/item/898128335908613/?mibextid=6ojiHh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-700 rounded-md flex items-center justify-center hover:border-cyan-400 hover:text-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="tel:9513509072"
                className="w-10 h-10 border border-gray-700 rounded-md flex items-center justify-center hover:border-cyan-400 hover:text-cyan-400 transition-all cursor-pointer"
              >
                <i className="ri-phone-fill text-lg"></i>
              </a>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-gray-500 text-sm hover:text-cyan-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
